import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { forwardRef, inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PriceListStoreHandlerService } from './price-list-store-handler.service';

export const PRICELIST_HEADER_INTERCEPTOR_PROVIDER = {
  provide: HTTP_INTERCEPTORS,
  useClass: forwardRef(() => PriceListInterceptor),
  multi: true,
};

@Injectable()
export class PriceListInterceptor implements HttpInterceptor {
  private priceListService = inject(PriceListStoreHandlerService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const priceList = this.priceListService.getCurrentValue();
    if (priceList) {
      request = request.clone({
        setHeaders: {
          pricelist: `${priceList.id}`,
        },
      });
    }
    return next.handle(request);
  }
}
